import { post } from "api/axios-client";
import {
  ChecklistTemplateRequest,
  ChecklistTemplateResponse,
  ChecklistTemplateFullResponse,
  transformFullTemplateResponseForUI,
} from "../types/checklistTemplateTypes";

const controllerUrl = "api/Checklist/";

export const saveChecklistTemplate = async (
  templateData: ChecklistTemplateRequest
): Promise<ChecklistTemplateResponse> => {
  try {
    const { data } = await post(
      `${controllerUrl}SaveChecklistTemplate`,
      templateData
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getChecklistTemplate = async (
  templateId: number
): Promise<ChecklistTemplateFullResponse | null> => {
  try {
    const { data } = await post(`${controllerUrl}GetChecklistTemplate`, {
      templateId,
    });
    // Transform the response to UI format
    return transformFullTemplateResponseForUI(data.content);
  } catch (error) {
    throw error;
  }
};
